import React from 'react';
import compose from 'recompose/compose';
import IconButton from 'material-ui/IconButton';
import Blank from 'material-ui/svg-icons/toggle/check-box-outline-blank';
import Checked from 'material-ui/svg-icons/toggle/check-box';
import { connect } from 'react-redux';
import { addItem as addItemAction, removeItem as removeItemAction } from './actions';

class Toggle extends React.Component {
  handleClick = () => {
    const { addItem, removeItem, items } = this.props;
    const id = this.props.record.id;
    if (!items.includes(id)) {
      addItem(id);
    } else {
      removeItem(id);
    }
  }

  render() {
    const { items } = this.props;
    const id = this.props.record.id;
    return (
      <div>
        <IconButton onClick={this.handleClick}>
          {items.includes(id) ? <Checked color="#00bcd4" /> : <Blank color="#00bcd4" />}
        </IconButton>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    items: state.customReducer.items
  };
};

function mapDispatchToProps(dispatch) {
  return {
    addItem: (id) => {
      dispatch(addItemAction(id));
    },
    removeItem: (id) => {
      dispatch(removeItemAction(id));
    },
  };
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(Toggle);



// WEBPACK FOOTER //
// ./src/custom/Toggle/CheckButton.js